// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./i18n";
import App from './App';

// If you used the CDN compat init in public/index.html, src/firebase should only
// export safe getters (no <script> tags). It's fine to keep or remove this import.
// import "./firebase";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from "./helpers/ScrollToTop";
import { Provider } from "react-redux";
import { storer, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import ErrorBoundary from './helpers/ExceptionHandler/componentException';
import Error404 from './layout/main/Error404';
import pushClient from './push-client';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <ErrorBoundary fallback={<Error404 />}>
    <Provider store={storer}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <ScrollToTop />
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </ErrorBoundary>
  // </React.StrictMode>
);


(async () => {
  try {
    const token = await pushClient.autoRegisterForPush({ retries: 2, delay: 2000 });
    console.log('Auto push token:', token);
  } catch (err) {
    console.warn('Auto push registration failed', err);
  }
})();

pushClient.listenForForegroundMessages(payload => {
  console.log('Foreground payload:', payload);
});

console.log('window.firebaseApp present?', !!window.firebaseApp);
console.log('window.firebaseMessaging present?', !!window.firebaseMessaging);


reportWebVitals();
